import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ChoferSucursalService {

  constructor(private gqlclient: GraphQLClient) { }

  obtenerchoferSucursalxRutEmpresaSucursal(inputParams: {
    entidad:{
      rut_empresa: number,
      sucursal_codigo: number,
      tipobusqueda: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: chofer_sucursalJoinInputType) {
          chofer_sucursal {
            obtenerchoferSucursalxRutEmpresaSucursal(entidad: $entidad, paginaActual: 1, cantidadRegistrosPorPagina: -1) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rut
                  nombre
                  estado
                  fono1
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.chofer_sucursal.obtenerchoferSucursalxRutEmpresaSucursal
        callback({ mensajes, respuesta })
      }
    );
  }

  agregarEditarChoferSucursal(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation($entidad: chofer_sucursalJoinInputType) {
          chofer_sucursal {
            agregaroEditarchoferSucursal(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rut
                nombre
                estado
                es_cliente
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.chofer_sucursal.agregaroEditarchoferSucursal
        callback({ mensajes, respuesta })
      }
    );
  }
}
